import { render, staticRenderFns } from "./AIAgent.MessageText.vue?vue&type=template&id=2f27f45a&lang=pug"
import script from "./AIAgent.MessageText.vue?vue&type=script&lang=js"
export * from "./AIAgent.MessageText.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.MessageText.vue?vue&type=style&index=0&id=2f27f45a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports